import { selectAnatomy } from "@chakra-ui/anatomy";
import { createMultiStyleConfigHelpers } from "@chakra-ui/react";
import ThemeColorConstant from "constants/ThemeColorsConstant";

import constantThemeColors from "constants/ThemeColorsConstant";

const { definePartsStyle, defineMultiStyleConfig } =
  createMultiStyleConfigHelpers(selectAnatomy.keys);

const outlineCustom = definePartsStyle({
  // define the part you're going to style
  // field: {
  //   borderRadius: "0px",
  //   borderWidth: "00",

  //   // paddingY: "1rem",
  //   _focusWithin: {
  //     // border: `1px solid ${constantThemeColors.secondaryColor}`,
  //     // ringColor: "red.400",

  //     ringColor: "purple.200",
  //     ring: "0px",
  //     // ringOffset: "1px",
  //     // ringOffsetColor: "purple.100",
  //     borderColor: "yellow.500",
  //   },
  // },
  field: {
    borderRadius: 0,
    borderColor: "#0000001F",
    border: "1px solid #0000001F ",

    _focusWithin: {
      ringColor: ThemeColorConstant.secondaryColor,
      ring: "1px",
      ringOffset: "1px",
      ringOffsetColor: "purple.100",
      borderColor: "purple.50",
    },
  },
  icon: {
    color: constantThemeColors.secondaryColor,
  },
});

const ChakraUISelectStyling = defineMultiStyleConfig({
  variants: { outlineCustom },
});

export default ChakraUISelectStyling;
